import React, { Suspense, lazy} from 'react'
import { Route, Routes as Switch, useLocation } from 'react-router-dom'
import { Splash, NotFound } from '../@uikit'
import { Fade } from '@chakra-ui/react'
import { useApp } from '../hooks'
import ScrollToTop from './scrollToTop'
const Login = lazy(() => import('../pages/Auth/Login'))
const Register = lazy(() => import('../pages/Auth/Register'))
const ForgetPassword = lazy(() => import('../pages/Auth/ForgetPassword'))
const DabashboardLayout = lazy(() => import('../layouts/DashboardLayout'))

const  Routes = () => {    
    
    const auth = useApp();
    const location = useLocation()
    
    if(auth.loading)
    {
        return(
            <Fade in={true}>
                <Splash />
            </Fade>
        )
    }        

    // console.log("Auth", auth)
    // console.log("Access Token", localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN))
    // console.log("Refresh Token", Cookies.get(process.env.REACT_APP_AUTH_COOKIE))

    if( !auth.loading && (window.is_empty(auth.user) || !localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)) ) 
    {
        return(
            <Fade in={true} key={location?.key}>
                <Suspense fallback={<Splash />}>                    
                    <ScrollToTop />
                    <Switch>                            
                        <Route exact path="/" element={<Login/>} />
                        <Route exact path="/register" element={<Register/>} />
                        <Route exact path="/forget-password" element={<ForgetPassword/>} />
                        <Route path="*" element={<NotFound />} />                            
                    </Switch>                    
                </Suspense>
            </Fade> 
        )
    }

    if(!window.is_empty(auth?.user)){
        return(
            <Fade in={true}>                
                <Suspense fallback={<Splash />}>
                    <Switch>
                        <Route path="/*" element={<DabashboardLayout/>} />                         
                    </Switch>                                        
                </Suspense>            
            </Fade> 
        )
    }

}

export default Routes;